import axiosInstance from '../utils/axios.js';

export const Employees = {
  async createEmployee(params) {
    const { data } = await axiosInstance.post('admin/employees', params);
    return data;
  },

  async updateEmployee(userId, params) {
    const { data } = await axiosInstance.put(`admin/employees/${userId}`, params);
    return data;
  },

  /**
   * Массовое удаление сотрудников интегратора (админка).
   * DELETE /api_v1/admin/employeees — тело: [{ id: "uuid" }, ...]
   */
  async deleteEmployeesBulk(employeesPayload) {
    const { data } = await axiosInstance.delete('admin/employees', {
      data: employeesPayload
    });
    return data;
  }
};

